import React, { useMemo } from 'react';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';
import DesktopContent from './DesktopContent';
import MobileContent from './MobileContent';
import { useWindowResize } from 'utils/hooks';

import * as styles from './EventLocations.module.scss';

const BLOCK_ID = 'event-locations';

export default function EventLocations({ title, subtitle, items }) {
  const { width } = useWindowResize();
  const isDesktop = width > 960;
  const preparedItems = useMemo(() => {
    const currentDate = new Date();
    const upcomingEvents = [];
    const pastEvents = [];
    items.forEach(item => {
      if (new Date(item.date) >= currentDate) {
        item.finished = false;
        upcomingEvents.push(item);
      } else {
        item.finished = true;
        pastEvents.push(item);
      }
      item.finished = new Date(item.date) < currentDate;
    });
    const sortedUpcoming = [...upcomingEvents].sort((a, b) => new Date(a.date) - new Date(b.date));
    const sortedPast = [...pastEvents].sort((a, b) => new Date(b.date) - new Date(a.date));
    return [...sortedUpcoming, ...sortedPast];
  }, [items]);
  return (
    <Container className={styles.container} id={BLOCK_ID} background="transparent">
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <p className={styles.subtitle}>{subtitle}</p>
        {isDesktop ? (
          <DesktopContent items={preparedItems} blockId={BLOCK_ID} />
        ) : (
          <MobileContent items={preparedItems} />
        )}
      </div>
    </Container>
  );
}
